import { Directive, HostBinding, ChangeDetectorRef, inject } from '@angular/core';
import { SafeStyle } from '@angular/platform-browser';
import { FormColorService } from '@formbird/services';

@Directive({
    selector: '[ftFormColor]',
    standalone: true
})
export class FormColorDirective {
  private formColorService = inject(FormColorService);
  private cd = inject(ChangeDetectorRef);


  @HostBinding('style.background-color') public background: SafeStyle;
  @HostBinding('class') class: string = 'background-color-holder';

  constructor() {
    const sub = this.formColorService.color$.subscribe(color => {
      this.background = color.background;
      this.cd.detectChanges();
    });
  }
}
